import React from 'react';

import { StaticItemsCustomSelect } from '@/components/molecules/StaticItemsCustomSelect';
import { useResolvedItems } from '@/hooks/useResolvedItems';
import { ItemsResolver } from '@/types/fields';

interface Props<ItemValueType extends string | number> {
  readonly name?: string;
  readonly label?: string;
  readonly itemResolver: ItemsResolver<ItemValueType>;
  readonly defaultValue?: ItemValueType | '';
  readonly value?: ItemValueType | '';
}

export function DynamicItemsCustomSelect<ItemValueType extends string | number>(
  props: Props<ItemValueType>,
): React.ReactElement {
  const { name, itemResolver, label, value, defaultValue } = props;
  const items = useResolvedItems(itemResolver);

  return (
    <StaticItemsCustomSelect
      name={name}
      label={label}
      items={items}
      defaultValue={defaultValue}
      value={value}
    />
  );
}
